import { __assign } from "tslib";
import * as React from 'react';
import { memo } from 'react';
var SvgLiveFilled24 = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", "data-test-id": "icons-live-filled-24", viewBox: "0 0 24 24", role: "img" }, props),
    React.createElement("title", null, 'Live Filled 24 Icon'),
    React.createElement("path", { fill: "currentColor", stroke: "currentColor", strokeWidth: 2, d: "m14.98 6.196.61-3.048-2.272 2.12-7.037 6.568C5.452 12.61 6 14 7.134 14H9.78l-.76 3.804-.61 3.048 2.272-2.12 7.037-6.568C18.548 11.39 18 10 16.866 10H14.22l.76-3.804Z" }))); };
var Memo = memo(SvgLiveFilled24);
export default Memo;
//# sourceMappingURL=LiveFilled24.js.map